import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor( private userService: UserService, private router: Router ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
      return new Promise((resolve, reject) => {
        if (this.userService.isLoggedIn()) {
          resolve(true);  
        } else {
          // Store the intended URL as a query parameter
          const returnUrl = state.url;
          this.router.navigate(['/login'], { queryParams: { returnUrl } });
          resolve(false);        
        }
      });

 
  }
  
}
